import { apiUrl } from "../constans";
import apiClient from '../libs/axios';

// Ver docs de backend: auditoria-plataforma-contrato-api.md
const API_BASE = `${apiUrl}/v2/super-admin`;

const unwrap = (response) => response.data?.data ?? response.data;

// En los 409 de asignar usuario el backend manda el texto en errorMessage y
// los datos (roles_actuales) en data; en el resto el texto viene en data
export const mensajeError = (error, porDefecto = 'Ha ocurrido un error') => {
    const body = error?.response?.data || {};
    if (typeof body.data === 'string' && body.data) return body.data;
    if (typeof body.errorMessage === 'string' && body.errorMessage) return body.errorMessage;
    return body.message || error?.message || porDefecto;
};

const descargarBlob = (blob, nombre) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nombre);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};

const nombreDesdeHeader = (headers) => {
    const disposition = headers?.['content-disposition'] || '';
    const match = disposition.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
    return match ? decodeURIComponent(match[1]) : null;
};

const plataforma = {
    namespaced: true,
    state: {
        auditoria: {
            data: [],
            current_page: 1,
            per_page: 25,
            last_page: 1,
            total: 0,
        },
        admins: [],
        tablas: [],
        roles: [],
    },

    mutations: {
        setAuditoria(state, paginador) {
            const stat = state.auditoria;
            stat.data = paginador.data || [];
            stat.current_page = paginador.current_page || 1;
            stat.per_page = paginador.per_page || 25;
            stat.last_page = paginador.last_page || 1;
            stat.total = paginador.total || 0;
        },

        setCurrentPage(state, page) {
            state.auditoria.current_page = page;
        },

        setAdmins(state, admins) {
            state.admins = admins;
        },

        setTablas(state, tablas) {
            state.tablas = tablas;
        },

        setRoles(state, roles) {
            state.roles = roles;
        },
    },

    actions: {
        // ---------- Auditoría ----------
        async getAuditoriaAction({ commit }, { filters = {}, page = 1 } = {}) {
            const response = await apiClient.get(`${API_BASE}/auditoria`, { params: { page, ...filters } });
            const paginador = unwrap(response) || {};
            commit('setAuditoria', paginador);
            return paginador;
        },

        async getAuditoriaDetalleAction(_, id) {
            const response = await apiClient.get(`${API_BASE}/auditoria/${id}`);
            return unwrap(response);
        },

        async getAdminsAction({ commit }) {
            const response = await apiClient.get(`${API_BASE}/auditoria/admins`);
            const admins = unwrap(response) || [];
            commit('setAdmins', admins);
            return admins;
        },

        // [{ tabla, total_cambios }] para el filtro
        async getTablasAction({ commit }) {
            const response = await apiClient.get(`${API_BASE}/auditoria/tablas`);
            const tablas = unwrap(response) || [];
            commit('setTablas', tablas);
            return tablas;
        },

        // Paginador con los cambios de un registro, del más reciente al más antiguo
        async getHistorialAction(_, { tabla, registroId, page = 1 }) {
            const response = await apiClient.get(`${API_BASE}/auditoria/historial`, {
                params: { tabla, registro_id: registroId, page },
            });
            return unwrap(response) || {};
        },

        async exportarAuditoriaAction(_, filters = {}) {
            try {
                const response = await apiClient.get(`${API_BASE}/auditoria/exportar`, {
                    params: filters,
                    responseType: 'blob',
                });
                const hoy = new Date().toISOString().slice(0, 10);
                descargarBlob(response.data, nombreDesdeHeader(response.headers) || `auditoria-plataforma-${hoy}.csv`);
            } catch (error) {
                // Con responseType blob el JSON de error también llega como Blob
                const data = error?.response?.data;
                if (data instanceof Blob) {
                    try {
                        error.response.data = JSON.parse(await data.text());
                    } catch (e) {
                        error.response.data = {};
                    }
                }
                throw error;
            }
        },

        // ---------- Roles de plataforma ----------
        async getRolesAction({ commit }) {
            const response = await apiClient.get(`${API_BASE}/roles-plataforma`);
            const roles = unwrap(response) || [];
            commit('setRoles', roles);
            return roles;
        },

        async crearRolAction(_, payload) {
            const response = await apiClient.post(`${API_BASE}/roles-plataforma`, payload);
            return unwrap(response);
        },

        async actualizarRolAction(_, { id, data }) {
            const response = await apiClient.put(`${API_BASE}/roles-plataforma/${id}`, data);
            return unwrap(response);
        },

        async eliminarRolAction(_, id) {
            const response = await apiClient.delete(`${API_BASE}/roles-plataforma/${id}`);
            return unwrap(response);
        },

        // 409 con data.roles_actuales si hay que confirmar
        async asignarUsuarioAction(_, { roleId, userId, confirmar = false }) {
            const response = await apiClient.post(`${API_BASE}/roles-plataforma/${roleId}/usuarios`, {
                user_id: userId,
                confirmar,
            });
            return unwrap(response);
        },

        async quitarUsuarioAction(_, { roleId, userId, nuevoRoleId }) {
            const response = await apiClient.delete(`${API_BASE}/roles-plataforma/${roleId}/usuarios/${userId}`, {
                data: { nuevo_role_id: nuevoRoleId },
            });
            return unwrap(response);
        },

        async buscarUsuariosAction(_, query = '') {
            const response = await apiClient.get(`${apiUrl}/v2/users`, { params: { search: query, page: 1 } });
            const data = unwrap(response);
            return Array.isArray(data) ? data : data?.data || [];
        },

        // Roles para devolver a un admin a una inmobiliaria (nunca de plataforma)
        async getRolesNoPlataformaAction() {
            const response = await apiClient.get(`${apiUrl}/auth/roles-us`);
            const roles = unwrap(response)?.roles || [];
            return roles.filter((r) => !Number(r.is_super_admin));
        },
    },
};

export default plataforma;
